module.exports = __webpack_public_path__ + "static/media/SF-3-A (1).28ba5e7d.mp3";